import React from 'react';
import PropTypes from 'prop-types';
import RemoteTag from '../RemoteTag/RemoteTag';
import { constructCn } from '../../../../utilities/helperFunctions';

import './JobTagBar.scss';

const kebabify = (str) =>
    str
        .split(' ')
        .map((w) => w.toLowerCase())
        .join('-');

const getJobTag = (expired, newJob, hiring) => {
    let tagText = '';

    // expired jobs have first precedence
    if (expired) tagText = 'Expired';
    // then new jobs
    else if (newJob) tagText = 'New';
    // then jobs of actively hiring companies
    else if (hiring) tagText = 'Actively Hiring';

    if (!tagText) return null;

    const tagCn = constructCn('job-tag', kebabify(tagText));

    return <span className={tagCn}>{tagText}</span>;
};

export const JobTagBar = ({
    isExpired,
    isNewJob,
    isActivelyHiring,
    isRemote,
}) => {
    const jobTag = getJobTag(isExpired, isNewJob, isActivelyHiring);

    const remoteTag = isRemote ? <RemoteTag /> : null;

    if (!jobTag && !remoteTag) return null;

    return (
        <div className="component-JobV3-Elements-JobTagBar">
            {jobTag}
            {remoteTag}
        </div>
    );
};

JobTagBar.propTypes = {
    isExpired: PropTypes.bool.isRequired,
    isNewJob: PropTypes.bool.isRequired,
    isActivelyHiring: PropTypes.bool.isRequired,
    isRemote: PropTypes.bool.isRequired,
};

JobTagBar.defaultProps = {};

JobTagBar.displayName = 'JobTagBar';

export default React.memo(JobTagBar);
